import { PictureProps, SourceType } from 'src/components/picture';
import { i18n } from 'src/i18n';

import strommeboxBackPng from './generated/strommebox-back.png';
import strommeboxBackWebp from './generated/strommebox-back.webp';
import strommeboxLeftPng from './generated/strommebox-left.png';
import strommeboxLeftWebp from './generated/strommebox-left.webp';
import strommeboxTopPng from './generated/strommebox-top.png';
import strommeboxTopWebp from './generated/strommebox-top.webp';

export const strommeboxBackPictureProps: PictureProps = {
  defaultSrc: strommeboxBackPng,
  alt: i18n.image.tvBox,
  sources: [
    {
      src: strommeboxBackWebp,
      type: SourceType.WEBP,
    },
  ],
};

export const strommeboxLeftPictureProps: PictureProps = {
  defaultSrc: strommeboxLeftPng,
  alt: i18n.image.tvBox,
  sources: [
    {
      src: strommeboxLeftWebp,
      type: SourceType.WEBP,
    },
  ],
};

export const strommeboxTopPictureProps: PictureProps = {
  defaultSrc: strommeboxTopPng,
  alt: i18n.image.tvBox,
  sources: [
    {
      src: strommeboxTopWebp,
      type: SourceType.WEBP,
    },
  ],
};
